<template>
  <div id="ths-user-editor">
    <ErrorPopup :error="error_popup_message" />

    <m-row>
      <m-col md="6" sm="12">
        <memlist-checkbox 
          text="Synka med CRM"
          style="margin-top: 20px;"
          v-model="local_item.sync_crm"
          @change="update_sync_crm"
        />
      </m-col>
    </m-row>
  </div>
</template>

<script>
import axios from 'axios';
import ErrorPopup from '@/view/components/ErrorPopup.vue';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';
import { mapGetters } from 'vuex';


export default {
  name: 'THSUserEditor',
  components: { ErrorPopup },
  mixins: [toasts],
  props: ['user'],
  emits: ['updated'],
  computed: {
    ...mapGetters(['currentCompanyId', 'currentPeriodId', 'pages', 'isTHS']),
  },
  data() {
    return {
      local_item: {
        sync_crm: false
      },
      error_popup_message: null
    };
  },
  watch: {
    user: {
      deep: true,
      immediate: true,
      handler(val) {
        if (val) {
          this.local_item = { ...val };
        }
      }
    }
  },
  methods: {
    async update_sync_crm() {
      try {
        if (!this.isTHS) {
          return;
        }

        const res = await axios.put(`/access/user/${this.local_item.user_id}`, {
          sync_crm: this.local_item.sync_crm
        });

        if (res.status === 200) {
          this.toastr('success', this.$t('COMMON.SUCCESS'), this.$t('USER.UPDATED'));
          this.$emit('updated', res.data);
        } else {
          throw new Error();
        }
      } catch (err) {
        console.error(err);
        this.error_popup_message = this.$t('USER.UNABLE_UPDATE');
        this.$nextTick(() => (this.error_popup_message = null));
        this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('USER.UNABLE_UPDATE'));
      }
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
